import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { HelpersService } from 'src/app/services/helpers.service';
import { InvoiceOptionsService } from 'src/app/services/invoice-options.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { ProductsService } from 'src/app/services/products.service';

const minSearchCharLen = 2;
@Component({
  selector: 'app-workshop-jobcard-quote-options',
  templateUrl: './workshop-jobcard-quote-options.component.html',
  styleUrls: ['./workshop-jobcard-quote-options.component.scss']
})
export class WorkshopJobcardQuoteOptionsComponent {

  @Input() public jobcard: any = {};
  @Input() messageService;
  @Input() invoiceOptions: any = [];
  @Output() update = new EventEmitter();

  public partner: any = {};
  public copyOptions: any = [];
  public selectedInvoiceOption: any = {};
  public busy: boolean = false;
  public updatingQuote: boolean = false;

  public currencySymbol = '';
  public VATInclusive = true;
  public VATRate = 0.15;
  public allowDiscount = false;
  public editLine: any = {};
  public searchResult: any = [];
  public discountType = '';
  public discounts: any = [];
  public lightSpeedDiscounts: any = [];
  public products: any = [];
  public searchExternalFlag = false;
  public searchExternalValue = '';
  public productSearch: any = '';
  public showAddNew = false;
  public newQuoteOption = {
    id: null,
    optionName: '',
    optionDescription: '',
    copyFromOption: null,
    copyFromMaster: false,
  };
  public templateActive = false;
  public showProductPanel: boolean = false;
  public sendToThirdPartyOnly: boolean = false;

  constructor(
    private invoiceOptionsService: InvoiceOptionsService,
    private helpersService: HelpersService,
    private productsService: ProductsService,
    private invoiceService: InvoiceService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
    public router: Router,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    this.currencySymbol = this.partner.CurrencySymbol;
    this.VATInclusive = this.partner.VATInclusive;
    this.VATRate = this.partner.VATRate;
    this.allowDiscount = this.partner.AllowDiscount || false;

    this.allowDiscount = this.partner.AllowDiscount || false;
    this.discountType =
      this.partner.POSSystemID === 6
        ? 'PERCENTAGE'
        : this.partner.POSSystemID === 3 || this.partner.POSSystemID === 8
          ? 'AMOUNT'
          : 'NONE';
    if (this.discountType === 'PERCENTAGE') {
      this.getLightSpeedDiscounts();
    }
    this.allowDiscount = this.partner.AllowDiscount || false;
    this.discountType =
      this.partner.POSSystemID === 6
        ? 'PERCENTAGE'
        : this.partner.POSSystemID === 3 || this.partner.POSSystemID === 8
          ? 'AMOUNT'
          : 'NONE';

    this.getInvoiceOptionsMessagingStatus();

    if (this.jobcard.thirdPartyID != null) {
      this.sendToThirdPartyOnly = true;
    }
  }

  getLightSpeedDiscounts() {
    this.invoiceService.getDiscounts(this.jobcard.partnerID).subscribe((discounts) => {
      this.lightSpeedDiscounts = discounts;
      this.discounts.push({ label: '0%', value: 0 });
      if (discounts && discounts.length > 0) {
        discounts.forEach((discount) => {
          this.discounts.push({
            label: discount.Name,
            value: parseInt(discount.ID),
          });
        });
      }
    });
  }

  openNewOptionContainer() {
    if (this.invoiceOptions === null || this.invoiceOptions.length === 0) {
      this.newQuoteOption.copyFromMaster = true;
    }
    this.showAddNew = true;
  }

  onTabOpen(event) {
    this.selectedInvoiceOption = this.invoiceOptions[event.index];
  }

  onTabClose(event) {
    this.selectedInvoiceOption = {};
  }

  updateCopyOptions() {
    if (this.invoiceOptions && this.invoiceOptions.length > 0) {
      this.copyOptions = this.invoiceOptions.map((x) => {
        return { value: x.id, label: x.optionName };
      });
      this.copyOptions.splice(0, 0, {
        value: '',
        label: this.translate.instant(
          'bikeshop.modal.update_job_card.select_option_to_copy',
        ),
      });
    }
  }

  getInvoiceOptions() {
    this.busy = true;
    this.invoiceOptionsService.getInvoiceOptions(this.jobcard.id).subscribe(
      (invoiceOptions) => {
        this.busy = false;
        this.invoiceOptions = invoiceOptions;
        this.updateCopyOptions();
      },
      (err) => {
        this.busy = false;
        this.invoiceOptions = [];
      },
    );
  }

  getInvoiceOptionsMessagingStatus() {
    this.busy = true;
    this.invoiceOptionsService
      .getInvoiceOptionsMessagingStatus(this.partner.ID)
      .subscribe(
        (status) => {
          this.templateActive = status.smsActive || status.emailActive;
          this.getInvoiceOptions();
        },
        (err) => {
          this.templateActive = false;
          this.busy = false;
        },
      );
  }

  updateOptionDescription(event) {
    event.deactivate();
    this.invoiceOptionsService
      .updateInvoiceOption(this.selectedInvoiceOption)
      .subscribe((result) => { });
  }

  addLineItem() {
    var option = this.invoiceOptions
      .filter((x) => {
        return x.id === this.selectedInvoiceOption.id;
      })
      .pop();
    option.invoiceQuoteOptionLineItem.push({ edit: true });
  }

  updateLineItem(lineItem) {
    this.updatingQuote = true;

    lineItem.discountOptions = this.lightSpeedDiscounts; //Pass the LS Discount options to the BE so it can calculate the discounts based on this, otherwise we have to make another call to LS slowing things down

    this.invoiceOptionsService.updateInvoiceOptionLineItem(lineItem).subscribe(
      (result) => {
        this.updatingQuote = false;
        result.forEach((option) => {
          var update = this.invoiceOptions
            .filter((x) => {
              return x.id === option.id;
            })
            .pop();
          update.invoiceQuoteOptionLineItem = option.invoiceQuoteOptionLineItem;
          update.total_Discounts = option.total_Discounts;
          update.total_LineItems = option.total_LineItems;
          update.total_Tax = option.total_Tax;
          update.total_Price = option.total_Price;
        });
      },
      (err) => {
        this.updatingQuote = false;
      },
    );
  }

  deleteLineItem(lineItem) {
    this.updatingQuote = true;
    this.invoiceOptionsService
      .deleteInvoiceOptionLineItem(lineItem.id)
      .subscribe(
        (result) => {
          this.updatingQuote = false;
          result.forEach((option) => {
            var update = this.invoiceOptions
              .filter((x) => {
                return x.id === option.id;
              })
              .pop();
            update.invoiceQuoteOptionLineItem =
              option.invoiceQuoteOptionLineItem;
            update.total_Discounts = option.total_Discounts;
            update.total_LineItems = option.total_LineItems;
            update.total_Tax = option.total_Tax;
            update.total_Price = option.total_Price;
          });
        },
        (err) => {
          this.updatingQuote = false;
        },
      );
  }

  editLineItem(lineItem) {
    console.log(lineItem);
  }

  resetNewOption() {
    this.newQuoteOption = {
      id: null,
      optionName: '',
      optionDescription: '',
      copyFromOption: null,
      copyFromMaster: false,
    };
    this.update.emit(this.invoiceOptions);
  }

  cancelQuoteOption() {
    this.showAddNew = false;
    this.resetNewOption();
  }

  addQuoteOption() {
    this.busy = true;
    var data = {
      ...this.newQuoteOption,
      ServiceID: this.jobcard.id,
      PartnerID: this.jobcard.partnerID,
    };

    this.invoiceOptionsService.addInvoiceOption(data).subscribe((options) => {
      this.invoiceOptions = options;
      this.updateCopyOptions();
      this.showAddNew = false;
      this.busy = false;
      this.resetNewOption();
    });
  }

  editQuoteOption(invoiceOption) {
    this.newQuoteOption = invoiceOption;
    this.showAddNew = true;
  }

  updateQuoteOption() {
    this.busy = true;
    var data = { ...this.newQuoteOption };
    this.invoiceOptionsService
      .updateInvoiceOption(data)
      .subscribe((options) => {
        this.invoiceOptions = options;
        this.updateCopyOptions();
        this.showAddNew = false;
        this.busy = false;
        this.resetNewOption();
      });
  }

  deleteQuoteOption(invoiceOption) {
    this.confirmationService.confirm({
      key: 'quote-option',
      rejectVisible: true,
      acceptLabel: this.translate.instant('general.yes'),
      rejectLabel: this.translate.instant('general.cancel'),
      header: this.translate.instant(
        'bikeshop.modal.update_job_card.delete_quote_option',
      ),
      message: this.translate.instant(
        'bikeshop.modal.update_job_card.delete_quote_option_message',
      ),
      accept: () => {
        this.busy = true;
        this.invoiceOptionsService
          .deleteInvoiceOption(invoiceOption.id)
          .subscribe((options) => {
            this.invoiceOptions = options;
            this.updateCopyOptions();
            this.showAddNew = false;
            this.busy = false;
            this.resetNewOption();
          });
      },
    });
  }

  sendQuoteOptions() {
    this.busy = true;
    this.invoiceOptionsService
      .sentInvoiceOptionsToCustomerV2(this.jobcard.id, (this.jobcard.thirdPartyID == null ? null : this.sendToThirdPartyOnly))
      .subscribe(
        (invoiceOptions) => {
          this.invoiceOptions = invoiceOptions;
          this.updateCopyOptions();
          this.busy = false;
          this.messageService.add({
            detail: this.translate.instant(this.jobcard.thirdPartyID != null && this.sendToThirdPartyOnly ? 'bikeshop.modal.update_job_card.quote_options_sent_to_third_party' : 'bikeshop.modal.update_job_card.quote_options_sent'),
            life: 5000
          });
          this.activeModal.close({ sent: true });
        },
        (err) => {
          this.busy = false;
        },
      );
  }

  canSendQuoteOptions() {
    var hasNotSentOption = false;
    var hasEmptyQuote = false;
    if (this.invoiceOptions && this.invoiceOptions.length > 0) {
      this.invoiceOptions.forEach((option) => {
        if (option.approvalStatus === 0) {
          hasNotSentOption = true;
        }
        if (option.invoiceQuoteOptionLineItem.length === 0) {
          hasEmptyQuote = true;
        }
      });
    }
    return hasNotSentOption && !hasEmptyQuote;
  }

  goToMessageTemplates() {
    this.activeModal.dismiss();
    this.router.navigateByUrl('/bikeshop/message-templates');
  }

  canUpdate(invoiceOption) {
    return invoiceOption.approvalStatus < 9;
  }

  skuSelected(event) {
    if (event.value) {
      event = event.value;
    }
    if (event.SKU && !event.UnitPrice) {
      this.productsService
        .searchInvoiceProduct(this.jobcard.partnerID, event.SKU)
        .subscribe((result) => {
          let products = result.filter((item) => {
            return item.Name === event.Name;
          });
          if (products.length > 0) {
            let product = products[0];
            product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
            product.ID = 0;
            product.Quantity = 1;
            product.Discount = 0;
            product.DiscountID = 0;
            product.OriginalUnitPrice = JSON.parse(
              JSON.stringify(product),
            ).UnitPrice;
            delete product.PartnerID;
            this.editLine = product;
          }
        });
    }
  }

  searchProducts(event) {
    this.searchExternalValue = event;
    //this.searchResult = [];

    //Return no resilts for 1 letter... this can slow browser allot. Might want to increase this if too many results get shown
    if (event.query.length < minSearchCharLen) {
      this.searchResult = [];
      return;
    }

    //if the external flag is on, dont try search the cache, go straight to the API as there is logic to direct that to the external products API.
    if (this.searchExternalFlag) {
      this.searchAPI(event);
      return;
    }

    //Try search the SKU type fields 1st
    var results = this.products.filter(function (product) {
      return (
        product.SKU.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        //product.Name.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        (!!product.SystemSKU &&
          product.SystemSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
          -1) ||
        (!!product.ManufacturerSKU &&
          product.ManufacturerSKU.toLowerCase().indexOf(
            event.query.toLowerCase(),
          ) > -1) ||
        (!!product.UPC &&
          product.UPC.toLowerCase().indexOf(event.query.toLowerCase()) > -1) ||
        (!!product.EAN &&
          product.EAN.toLowerCase().indexOf(event.query.toLowerCase()) > -1) ||
        (!!product.CustomSKU &&
          product.CustomSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
          -1)
      );
    });

    //Use a different search to filter the Name field, this now can search the field with words in any order.
    var nameResults = this.filterList(event.query, this.products);
    if (nameResults && nameResults.length > 0) {
      nameResults.forEach((result) => {
        if (
          results.filter((x) => {
            return x.ID == result.ID;
          }).length === 0
        ) {
          results.push(result);
        }
      });
    }

    results = JSON.parse(JSON.stringify(results)).map((product) => {
      product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
      product.ID = 0;
      product.Quantity = 1;
      product.Discount = 0;
      product.DiscountID = 0;
      product.OriginalUnitPrice = JSON.parse(JSON.stringify(product)).UnitPrice;
      delete product.PartnerID;
      return product;
    });

    if (
      this.partner.AllowExactMatchingOnQuote &&
      results.length === 1 &&
      this.exactMatch(event.query, results[0])
    ) {
      this.addLineItemAuto({ ...results[0] });
    } else if (results.length > 0) {
      this.searchResult = results;
      this.limitResults();
    } else {
      if (
        results.length === 0 &&
        event.query.length > minSearchCharLen &&
        (event.query.length > this.editLine.length - 1 ||
          event.query.length > this.productSearch.length - 1)
      ) {
        //remove last character from the search and try again - Seems certain UPC products barcodes have an extra digit
        event.originalQuery = event.query;
        event.query = event.query.substr(0, event.query.length - 1);
        this.searchProducts(event);
      } else {
        //If the search above returns no records, search the DB
        if (
          event.originalQuery ||
          event.query.length === this.editLine.length - 1 ||
          event.query.length === this.productSearch.length - 1
        ) {
          event.query = event.originalQuery ? event.originalQuery : event.query;
          if (event.originalQuery) {
            delete event.originalQuery;
          }
          this.searchAPI(event);
        } else {
          this.searchResult = [];
        }
      }
    }
  }

  searchAPI(event) {
    if (!this.searchExternalFlag) {
      this.productsService
        .searchProductV2(this.jobcard.partnerID, event.query)
        .subscribe(
          (results) => {
            if (this.partner.AllowExactMatchingOnQuote && results.ExactMatch) {
              var item = results.products[0];
              this.addLineItemAuto({
                ID: item.ID,
                SKU: item.Description,
                Name: item.Data,
                Quantity: 1,
                Discount: 0,
                DiscountID: 0,
              });
            } else if (
              results.products.length === 0 &&
              event.query.length > minSearchCharLen &&
              (event.query.length > this.editLine.length - 1 ||
                event.query.length > this.productSearch.length - 1)
            ) {
              event.query = event.query.substr(0, event.query.length - 1);
              this.searchProducts(event);
            } else {
              this.searchResult = results.products.map((item) => {
                return {
                  ID: item.ID,
                  SKU: item.Description,
                  Name: item.Data,
                  UnitPrice: item.UnitPrice,
                  UnitPrice_IncludingTax: item.UnitPrice_IncludingTax,
                  Quantity: 1,
                  Discount: 0,
                  DiscountID: 0,
                };
              });
            }
          },
          (err) => {
            if (
              err &&
              event.query.length > minSearchCharLen &&
              (event.query.length > this.editLine.length - 1 ||
                event.query.length > this.productSearch.length - 1)
            ) {
              event.query = event.query.substr(0, event.query.length - 1);
              this.searchProducts(event);
            }
          },
        );
    } else {
      this.productsService
        .searchExternalProduct(this.jobcard.partnerID, event.query)
        .subscribe(
          (results) => {
            if (
              results.products.length === 0 &&
              event.query.length > minSearchCharLen &&
              (event.query.length > this.editLine.length - 1 ||
                event.query.length > this.productSearch.length - 1)
            ) {
              event.query = event.query.substr(0, event.query.length - 1);
              this.searchProducts(event);
            } else {
              this.searchResult = JSON.parse(
                JSON.stringify(results.products),
              ).map((product) => {
                product.InternalProductID = JSON.parse(
                  JSON.stringify(product),
                ).ID;
                product.ID = 0;
                product.Quantity = 1;
                product.Discount = 0;
                product.DiscountID = 0;
                product.OriginalUnitPrice = JSON.parse(
                  JSON.stringify(product),
                ).UnitPrice;
                delete product.PartnerID;
                return product;
              });
            }
          },
          (err) => {
            if (
              err &&
              event.query.length > minSearchCharLen &&
              (event.query.length > this.editLine.length - 1 ||
                event.query.length > this.productSearch.length - 1)
            ) {
              event.query = event.query.substr(0, event.query.length - 1);
              this.searchProducts(event);
            }
          },
        );
    }
  }

  filterList(q, list) {
    function escapeRegExp(s) {
      return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    const words = q
      .split(/\s+/g)
      .map((s) => s.trim().toLowerCase())
      .filter((s) => !!s);

    const hasTrailingSpace = q.endsWith(' ');
    const searchRegex = new RegExp(
      words
        .map((word, i) => {
          if (words.length === 1) {
            return `(.*${escapeRegExp(word)}.*)`;
          } else {
            return `(?=.*\\b${escapeRegExp(word)})`;
          }
        })
        .join(''),
      'gi',
    );

    var resultList = list.filter((item) => {
      return searchRegex.test(item.Name);
    });

    resultList.forEach((res) => {
      var nameArray = res.Name.split(' ');
      var count = 0;
      nameArray.forEach((name) => {
        if (words.includes(name.toLowerCase())) {
          count += 1;
        }
      });
      res.wordMatch = count;
    });

    resultList = resultList.sort((a, b) => {
      if (a.wordMatch > b.wordMatch) {
        return -1;
      } else if (a.wordMatch < b.wordMatch) {
        return 1;
      } else {
        return 0;
      }
    });

    return resultList;
  }

  limitResults() {
    if (!this.searchExternalFlag) {
      this.searchResult = this.searchResult.filter(function (product) {
        return product.ExternalProductID !== '';
      });
    } else {
      this.searchResult = this.searchResult.filter(function (product) {
        return product.ExternalProductID === '';
      });
    }
  }

  exactMatch(query, item) {
    return (
      query &&
      query.length > 0 &&
      (query === item.SKU ||
        query === item.ManufacturerSKU ||
        query === item.SystemSKU ||
        query === item.EAN ||
        query === item.UPC)
    );
  }

  addLineItemAuto(event) {
    if (event.value) {
      event = event.value;
    }

    if (event.SKU && !event.InternalProductID) {
      this.productsService
        .searchInvoiceProduct(this.jobcard.partnerID, event.SKU)
        .subscribe((result) => {
          let products = result.filter((item) => {
            return item.Name === event.Name;
          });
          if (products.length > 0) {
            let product = products[0];
            product.Quantity = 1;
            product.Discount = 0;
            product.DiscountID = 0;
            product.InternalProductID = product.ID;
            product.InvoiceOptionID = this.selectedInvoiceOption.id;
            this.updatingQuote = true;
            this.productSearch = '';
            this.invoiceOptionsService
              .addInvoiceOptionLineItem(product)
              .subscribe(
                (result) => {
                  this.updatingQuote = false;
                  result.forEach((option) => {
                    var update = this.invoiceOptions
                      .filter((x) => {
                        return x.id === option.id;
                      })
                      .pop();
                    update.invoiceQuoteOptionLineItem =
                      option.invoiceQuoteOptionLineItem;
                    update.total_Discounts = option.total_Discounts;
                    update.total_LineItems = option.total_LineItems;
                    update.total_Tax = option.total_Tax;
                    update.total_Price = option.total_Price;
                  });
                },
                (err) => {
                  this.updatingQuote = false;
                },
              );
          }
        });
    } else {
      let product = event;
      product.Quantity = 1;
      product.Discount = 0;
      product.DiscountID = 0;
      product.InternalProductID = product.ID;
      product.InvoiceOptionID = this.selectedInvoiceOption.id;
      this.updatingQuote = true;
      this.productSearch = '';
      this.invoiceOptionsService.addInvoiceOptionLineItem(product).subscribe(
        (result) => {
          this.updatingQuote = false;
          result.forEach((option) => {
            var update = this.invoiceOptions
              .filter((x) => {
                return x.id === option.id;
              })
              .pop();
            update.invoiceQuoteOptionLineItem =
              option.invoiceQuoteOptionLineItem;
            update.total_Discounts = option.total_Discounts;
            update.total_LineItems = option.total_LineItems;
            update.total_Tax = option.total_Tax;
            update.total_Price = option.total_Price;
          });
        },
        (err) => {
          this.updatingQuote = false;
        },
      );
    }
  }

  productPanelVisible(lineItem) {
    lineItem.lineItemNoteUpdate = lineItem.lineItemNote;
    this.showProductPanel = true;

    setTimeout(() => {
      const overlayElement = document.querySelector('.p-overlaypanel');
      if (overlayElement) {
        (overlayElement as HTMLElement).style.setProperty('z-index', '2500', 'important');
      }
    }, 0);
  }

  productPanelHidden() {
    this.showProductPanel = false;
  }

  updateLineItemNote(lineItem, event) {
    event.hide();
    lineItem.lineItemNote = lineItem.lineItemNoteUpdate;
    this.updateLineItem(lineItem);

  }
}